import React from "react";
import PropTypes from "prop-types";

const ACTION_ICON = {
  submit:   { icon: "bi-send-fill",              cls: "text-primary"  },
  approve:  { icon: "bi-check-circle-fill",      cls: "text-success"  },
  reject:   { icon: "bi-x-circle-fill",          cls: "text-danger"   },
  hold:     { icon: "bi-pause-circle-fill",       cls: "text-warning"  },
  unhold:   { icon: "bi-play-circle-fill",        cls: "text-success"  },
  reassign: { icon: "bi-arrow-left-right",        cls: "text-info"     },
  system_action_execute: { icon: "bi-lightning-fill",          cls: "text-primary" },
  system_action_success: { icon: "bi-check2-circle",           cls: "text-success" },
  system_action_failure: { icon: "bi-exclamation-circle-fill", cls: "text-danger"  },
};

function formatTs(ts) {
  if (!ts) return "";
  return new Date(ts).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
}

export default function StageHistoryTimeline({ history }) {
  if (!history?.length) {
    return <p className="text-muted small py-3 text-center">No history yet.</p>;
  }

  return (
    <div className="t2t-timeline">
      {history.map((entry, i) => {
        const meta = ACTION_ICON[entry.action_type] || { icon: "bi-circle", cls: "text-muted" };
        return (
          <div key={entry.action_id || i} className="d-flex gap-3 mb-3">
            <div className="d-flex flex-column align-items-center">
              <div
                className={`rounded-circle d-flex align-items-center justify-content-center bg-white border ${meta.cls}`}
                style={{ width: 28, height: 28, minWidth: 28, fontSize: 13 }}
              >
                <i className={`bi ${meta.icon}`} />
              </div>
              {i < history.length - 1 && (
                <div style={{ width: 2, flex: 1, minHeight: 16, background: "#e5e7eb", marginTop: 2 }} />
              )}
            </div>
            <div className="pb-2" style={{ flex: 1 }}>
              <div className="d-flex align-items-baseline gap-2 flex-wrap">
                <span className="fw-semibold" style={{ fontSize: 13 }}>
                  {entry.actor_name || "System"}
                </span>
                <span className="text-muted" style={{ fontSize: 12 }}>
                  {entry.action_type?.replace(/_/g, " ")}
                </span>
                {entry.stage_name && (
                  <span className="badge bg-light text-dark border" style={{ fontSize: 11 }}>
                    {entry.stage_name}
                  </span>
                )}
              </div>
              {entry.comment && (
                <p className="mb-0 mt-1 text-secondary" style={{ fontSize: 12 }}>
                  &ldquo;{entry.comment}&rdquo;
                </p>
              )}
              <small className="text-muted d-block mt-1" style={{ fontSize: 11 }}>
                {formatTs(entry.created_at)}
              </small>
            </div>
          </div>
        );
      })}
    </div>
  );
}

StageHistoryTimeline.propTypes = {
  history: PropTypes.arrayOf(PropTypes.shape({
    action_id:   PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    action_type: PropTypes.string,
    comment:     PropTypes.string,
    created_at:  PropTypes.string,
    actor_name:  PropTypes.string,
    stage_name:  PropTypes.string,
  })),
};
